import { Power0, Power1, Power2, Power3, Power4, Sine } from 'gsap';

window.Power0 = Power0;
window.Power1 = Power1;
window.Power2 = Power2;
window.Power3 = Power3;
window.Power4 = Power4;
window.Sine = Sine;